import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App);

const globalMixIn = {
	mounted() {
		// ページタイトルをDOM（document.title）で設定
		let { title } = this.$options;
		if (title) {
			document.title = title + " - ASSIST BMW tuning";
		}
	},
};
app.mixin(globalMixIn);

app.use(store).use(router).mount("#apps");
